<template>
    <div>
        <div class="logo-upload">
            <label class="logo-upload__image-container">
                <div for="image-upload" class="logo-upload__label">
                    {{ translate(label) }}
                </div>
                <div class="logo-upload__image">
                    <loading-overlay v-if="isLoading"/>
                    <image-upload
                        :cover=true
                        :src="src"
                        :size="size"
                        @click="onClicked"
                        @change="onChanged"
                        @onDelete="onDelete"
                        :edit-cover="true"
                        :delete-cover="true"
                    />
                </div>
            </label>
            <div class="logo-upload__requirements">
                <div class="logo-upload__requirements-title">
                    {{ translate(rulesTitle) }}
                </div>
                <ul class="logo-upload__requirements-list">
                    <li
                        v-for="(item, key) in rules"
                        :key="key"
                        class="logo-upload__requirements-list-item"
                    >{{ translate(item) }}</li>
                </ul>
            </div>
        </div>
        <div
            v-if="errors.length"
            class="logo-upload__error-container"
        >
            <div class="logo-upload__error--bold">
                {{ uploadFailed }}
            </div>
            <div
                v-for="(error, index) in errors"
                :key="index"
                class="logo-upload__error"
            >{{ error }}</div>
        </div>
    </div>

</template>

<script>
    import ImageUpload from './image-upload.vue';
    import LoadingOverlay from './loading-overlay.vue';
    import ErrorsHelper from '../helpers/errors';
    import Polling from '../helpers/polling';
    import {_T} from '../globals';

    export default {
        props: ['model', 'label', 'rules', 'rulesTitle'],
        components: { LoadingOverlay, ImageUpload },
        data() {
            return {
                size: '150x150',
                src: this.model.logo.length !== 0 ? this.model.logo[150].href : null,
                isLoading: false,
                errors: [],
                uploadFailed: _T('upload_failed')
            };
        },
        methods: {
            onClicked() {
                this.errors = [];
            },
            onChanged($event) {
                this.isLoading = true;

                this.model.repository.uploadLogo(this.model.id, $event.target.files[0])
                    .then(() => {
                        this.model.repository.getLogo(this.model.id, 150)
                            .then((src) => {
                                Polling.pollFile(src)
                                    .then(() => {
                                        this.src = src;
                                        this.isLoading = false;
                                    });
                            });
                    })
                    .catch((error) => {
                        this.errors = ErrorsHelper.toArray(error);
                        this.isLoading = false;
                    });
            },
            onDelete(event) {
                this.isLoading = true;

                this.model.repository.deleteLogo(this.model.id)
                    .then(this.clean)
                    .catch(this.clean);
                event.preventDefault();
            },
            clean() {
                this.src = null;
                this.isLoading = false;
            },
            translate(string) {
                return _T(string);
            }
        }
    };
</script>

<style lang="scss">
    .logo-upload {
        display: flex;
        flex-flow: row nowrap;
        position: relative;
        padding: 0 0 0.75rem 0;
        width: 100%;

        &__image-container {
            display: flex;
            flex-flow: row nowrap;
        }

        &__image {
            position: relative;
            width: 150px;
            height: 150px;
            background-color: #fff;
            border-radius: 0.3125rem;
        }

        &__label {
            width: 222px;
        }

        &__requirements {
            padding: 0.5rem 1.5rem;
        }

        &__requirements-title {
            margin-bottom: 0.25rem;
            line-height: 1.225rem;
            font-size: 0.875rem;
            font-weight: 500;
        }

        &__requirements-list {
            line-height: 1.225rem;
            font-size: 0.875rem;
            margin-bottom: 1rem;
        }

        &__requirements-list-item {
            font-weight: 400;
        }

        &__requirements-list-item:before {
            content: '\2022';
            margin: 0 0.25rem 0 0;
            line-height: 1;
            font-size: 1.25rem;
            font-weight: 400;
        }

        &__error-container {
            margin: 0.5rem 0 0.5rem 13.6875rem;
            color: #f03d3d;
        }

        &__error {
            display: block;
            line-height: 16.8px;
            font-size: 12px;

            &--bold {
                background-image: url('/images/default/error.svg');
                background-repeat: no-repeat;
                background-position: left top;
                background-size: 14px;
                padding-left: 1.3rem;
                margin-top: 0.3rem;
                width:100%;
                color: #f03d3d;

                margin-bottom: 0.25rem;
                font-size: 0.875rem;
                font-weight: 600;
            }
        }
    }
</style>
